import comp from "./TagResourceV3";
export default comp;
